import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookOpenIcon, ClockIcon, FileTextIcon } from 'lucide-react';
import { tomos } from '../data/tomos';
export function Tomos() {
  const [activeId, setActiveId] = useState(tomos[0].id);
  const active = tomos.find(tomo => tomo.id === activeId) ?? tomos[0];
  return <section className="w-full bg-ink-100 py-20 lg:py-28" aria-labelledby="tomos-heading" data-id="element-214" data-mp="1cb2w2y6jja2p">
      <div className="mx-auto max-w-content px-6" data-id="element-215" data-mp="1qzp8os4s9nq8">
        <div className="max-w-2xl" data-id="element-216" data-mp="1m2flzk8s3q63">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-flare-600" data-id="element-217" data-mp="1m1e1kp5vhrbp">
            Arquitectura del producto
          </p>
          <h2 id="tomos-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-218" data-mp="1zzm3zclohku9">
            Los 4 tomos, en detalle
          </h2>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[300px_1fr] lg:gap-12" data-id="element-219" data-mp="5q0cpnt4mzbf">
          <div role="tablist" aria-orientation="vertical" aria-label="Tomos del pack" className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0" data-id="element-220" data-mp="1nwzatmwdkni">
            {tomos.map(tomo => {
            const isActive = tomo.id === active.id;
            return <button key={tomo.id} type="button" role="tab" id={`tab-${tomo.id}`} aria-selected={isActive} aria-controls={`panel-${tomo.id}`} onClick={() => setActiveId(tomo.id)} className={`min-w-[230px] shrink-0 rounded-lg border px-5 py-4 text-left transition-colors duration-150 ease-swift focus:outline-none focus-visible:ring-4 focus-visible:ring-flare-500/30 lg:min-w-0 ${isActive ? 'border-ink-950 bg-ink-950 text-white' : 'border-ink-950/10 bg-white text-ink-950 hover:border-ink-950/30'}`} data-id="element-221" data-mp="3eomdmpj71wek">
                  <span className={`text-[11px] font-bold uppercase tracking-[0.16em] ${isActive ? 'text-flare-500' : 'text-ink-500'}`} data-id="element-222" data-mp="69ce9p6ov5ah">
                    {tomo.tab}
                  </span>
                  <span className="mt-1 block text-sm font-bold leading-snug" data-id="element-223" data-mp="27znx7eq3r6a1">
                    {tomo.tabSubtitle}
                  </span>
                </button>;
          })}
          </div>

          <AnimatePresence mode="wait" data-id="element-224" data-mp="1vyobq5sxsc5m">
            <motion.div key={active.id} role="tabpanel" id={`panel-${active.id}`} aria-labelledby={`tab-${active.id}`} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -4
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-8 rounded-xl border border-ink-950/10 bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,320px)_1fr] lg:gap-10" data-id="element-225" data-mp="1vzzbzvn6b1rz">
              <div data-id="element-226" data-mp="2npc874jo0tcy">
                <img src={active.image} alt={active.imageAlt} className={`w-full rounded-lg object-cover ${active.isCover ? 'aspect-[3/4] shadow-xl shadow-ink-950/20' : 'aspect-[4/3]'}`} width={800} height={active.isCover ? 1066 : 600} data-id="element-227" data-mp="2nou3rkmun8ty" />
                <dl className="mt-5 grid grid-cols-2 gap-3" data-id="element-228" data-mp="3lawwg270asps">
                  <div className="rounded-lg bg-ink-100 px-4 py-3 ring-1 ring-ink-950/5" data-id="element-229" data-mp="3la40zxdhzpmy">
                    <dt className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-230" data-mp="37am6d1diti5o">
                      <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-231" data-mp="3cc1uj2azw4sa" /> Extensión
                    </dt>
                    <dd className="mt-1 text-sm font-bold text-ink-950" data-id="element-232" data-mp="32bss36qetn4g">{active.pages}</dd>
                  </div>
                  <div className="rounded-lg bg-ink-100 px-4 py-3 ring-1 ring-ink-950/5" data-id="element-233" data-mp="2ol64a9m6thn5">
                    <dt className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-234" data-mp="2tjhdci4nro4b">
                      <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-235" data-mp="2eni0yvain1td" /> Tiempo
                    </dt>
                    <dd className="mt-1 text-sm font-bold text-ink-950" data-id="element-236" data-mp="2jk8fvfal3rd7">{active.readingTime}</dd>
                  </div>
                </dl>
              </div>

              <div data-id="element-237" data-mp="3hwueyx2mr6nk">
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-flare-600" data-id="element-238" data-mp="3hyf94ll18nkw">
                  {active.tab} — {active.tabSubtitle}
                </p>
                <h3 className="mt-2 text-2xl font-black leading-tight tracking-tight text-ink-950" data-id="element-239" data-mp="387ucv4stzv55">
                  {active.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-ink-600" data-id="element-240" data-mp="33a16aanm8z4c">{active.intro}</p>

                <h4 className="mt-7 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-ink-950" data-id="element-241" data-mp="2z5bfh07teaqa">
                  <BookOpenIcon className="h-4 w-4 text-flare-600" aria-hidden="true" data-id="element-242" data-mp="2u9w4cg16ysxk" />
                  Capítulos clave
                </h4>
                <ul className="mt-3 divide-y divide-ink-950/10 border-t border-ink-950/10" data-id="element-243" data-mp="sgonh25xk39k">
                  {active.chapters.map(chapter => <li key={chapter} className="py-2.5 text-sm leading-relaxed text-ink-700" data-id="element-244" data-mp="nin2ucsuvvvz">
                      {chapter}
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}